
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.179.251c.73 0 1.43.29 1.945.806l2.829 2.83a2.75 2.75 0 01.806 1.944v11.177a2.75 2.75 0 01-2.751 2.75H3.106a2.75 2.75 0 01-2.75-2.73L.25 3.023A2.752 2.752 0 013.002.25zm-8.933 1.5H3.002a1.25 1.25 0 00-1.25 1.26l.103 14.006a1.25 1.25 0 001.251 1.242h13.902a1.25 1.25 0 001.25-1.251V5.83c0-.331-.131-.65-.366-.884l-2.83-2.83a1.25 1.25 0 00-.311-.227l-.001 3.113c0 .918-.708 1.671-1.607 1.744l-.144.006H6.996a1.751 1.751 0 01-1.744-1.607l-.006-.143V1.75zm4.759 7.504a3.251 3.251 0 110 6.502 3.251 3.251 0 010-6.502zm0 1.5a1.751 1.751 0 100 3.502 1.751 1.751 0 000-3.502zm3.244-9.004H6.746v3.252a.25.25 0 00.193.244l.058.006h6.002a.25.25 0 00.244-.193l.007-.057V1.75z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    